import React from 'react';
import { Search, Eye } from 'lucide-react';

interface SEOSnippetPreviewProps {
  title: string;
  description: string;
  url: string;
  searchEngine: 'google' | 'yandex';
}

const SEOSnippetPreview: React.FC<SEOSnippetPreviewProps> = ({ title, description, url, searchEngine }) => {
  const displayUrl = url || 'https://rabotamax.ru';
  const displayTitle = title || 'Заголовок страницы';
  const displayDescription = description || 'Описание страницы';

  // Валидация длины
  const titleLength = displayTitle.length;
  const descriptionLength = displayDescription.length;
  const titleWarning = titleLength > 60;
  const descriptionWarning = descriptionLength > 160;

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          {searchEngine === 'google' ? (
            <Search className="h-5 w-5 text-gray-600" />
          ) : (
            <Eye className="h-5 w-5 text-gray-600" />
          )}
          <span className="text-sm font-medium text-gray-700">
            {searchEngine === 'google' ? 'Google' : 'Яндекс'}
          </span>
        </div>
        <div className="text-xs text-gray-500">
          {titleLength}/60 {descriptionLength}/160
        </div>
      </div>

      <div className="space-y-2">
        {/* URL */}
        <div className="text-sm text-green-700 truncate">
          {displayUrl}
        </div>

        {/* Title */}
        <div>
          <h3
            className={`text-xl text-blue-600 hover:underline cursor-pointer ${
              titleWarning ? 'text-red-600' : ''
            }`}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {displayTitle}
          </h3>
          {titleWarning && (
            <p className="text-xs text-red-600 mt-1">
              Заголовок слишком длинный (рекомендуется до 60 символов)
            </p>
          )}
        </div>

        {/* Description */}
        <div>
          <p
            className={`text-sm text-gray-600 ${
              descriptionWarning ? 'text-red-600' : ''
            }`}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {displayDescription}
          </p>
          {descriptionWarning && (
            <p className="text-xs text-red-600 mt-1">
              Описание слишком длинное (рекомендуется до 160 символов)
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SEOSnippetPreview;

